(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const checkoutBtn = document.getElementById('checkout-btn');
  const cartForm = document.getElementById('cart-form');
  const removeButtons = document.querySelectorAll('.btn-remove-item');
  
  // Checkout functionality
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function() {
      // Update quantities before checkout
      const quantityInputs = document.querySelectorAll('.quantity-input');
      const hiddenInputs = cartForm.querySelectorAll('input[name="updates[]"]');
      
      quantityInputs.forEach((input, index) => {
        if (hiddenInputs[index]) {
          hiddenInputs[index].value = input.value;
        }
      });
      
      // Redirect to checkout
      window.location.href = '/checkout';
    });
  }
  
  // Remove item functionality
  removeButtons.forEach(button => {
    button.addEventListener('click', function() {
      const itemKey = this.getAttribute('data-item-key');
      
      // Show loading state for the item being removed
      const itemContainer = button.closest('.cart-item');
      itemContainer.style.opacity = '0.5';
      button.disabled = true;
      
      // Use the cart change API to remove item
      const formData = new FormData();
      formData.append('id', itemKey);
      formData.append('quantity', 0);
      
      fetch('/cart/change.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(cart => {
        // Remove the item from the DOM
        itemContainer.remove();
        
        // Update cart count
        const cartCountElements = document.querySelectorAll('.cart-count, .cart-count-bubble');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count;
        });
        
        // Update cart totals
        updateCartTotals(cart);
        
        // If cart is empty, refresh the page to show empty state
        if (cart.item_count === 0) {
          window.location.reload();
        }
      })
      .catch(error => {
        console.error('Error removing item:', error);
        
        // Reset item state on error
        itemContainer.style.opacity = '1';
        button.disabled = false;
        
        // Show error message
        showCartError('Failed to remove item. Please try again.');
      });
    });
  });
  
  // Quantity increment/decrement functionality
  const quantityButtons = document.querySelectorAll('.btn-quantity');
  quantityButtons.forEach(button => {
    button.addEventListener('click', function() {
      const itemKey = this.getAttribute('data-item-key');
      const input = document.querySelector(`input[data-item-key="${itemKey}"]`);
      const currentValue = parseInt(input.value);
      
      // Store current quantity before updating
      storeCurrentQuantity(itemKey);
      
      if (this.classList.contains('btn-quantity-plus')) {
        input.value = currentValue + 1;
      } else if (this.classList.contains('btn-quantity-minus') && currentValue > 1) {
        input.value = currentValue - 1;
      }
      
      // Update cart automatically
      updateCartItem(itemKey, input.value);
    });
  });
  
  // Manual quantity input changes with debouncing
  const quantityInputs = document.querySelectorAll('.quantity-input');
  const updateTimeouts = new Map();
  
  quantityInputs.forEach(input => {
    input.addEventListener('input', function() {
      const itemKey = this.getAttribute('data-item-key');
      const quantity = parseInt(this.value);
      
      if (quantity < 1) {
        this.value = 1;
        return;
      }
      
      // Clear existing timeout for this input
      if (updateTimeouts.has(itemKey)) {
        clearTimeout(updateTimeouts.get(itemKey));
      }
      
      // Set new timeout to update cart after 500ms of no typing
      const timeoutId = setTimeout(() => {
        // Store current quantity before updating
        storeCurrentQuantity(itemKey);
        
        // Update cart automatically
        updateCartItem(itemKey, quantity);
        
        // Clear timeout reference
        updateTimeouts.delete(itemKey);
      }, 500);
      
      updateTimeouts.set(itemKey, timeoutId);
    });
    
    // Also handle blur event for immediate update when user leaves the input
    input.addEventListener('blur', function() {
      const itemKey = this.getAttribute('data-item-key');
      const quantity = parseInt(this.value);
      
      if (quantity < 1) {
        this.value = 1;
        quantity = 1;
      }
      
      // Clear any pending timeout
      if (updateTimeouts.has(itemKey)) {
        clearTimeout(updateTimeouts.get(itemKey));
        updateTimeouts.delete(itemKey);
      }
      
      // Store current quantity before updating
      storeCurrentQuantity(itemKey);
      
      // Update cart immediately
      updateCartItem(itemKey, quantity);
    });
  });
  
  // Function to update cart item and refresh pricing
  function updateCartItem(itemKey, quantity) {
    // Show loading state for the specific item
    const itemContainer = document.querySelector(`[data-item-key="${itemKey}"]`).closest('.cart-item');
    const priceContainer = itemContainer.querySelector('.cart-item-price');
    priceContainer.classList.add('loading');
    
    // Hide any existing errors
    hideCartError();
    
    const formData = new FormData();
    formData.append('id', itemKey);
    formData.append('quantity', quantity);
    
    fetch('/cart/change.js', {
      method: 'POST',
      body: formData
    })
    .then(response => {
      if (!response.ok) {
        if (response.status === 422) {
          return response.json().then(errorData => {
            throw new Error(errorData.description || 'Quantity limit exceeded');
          });
        }
        throw new Error('Failed to update cart');
      }
      return response.json();
    })
    .then(cart => {
      // Update cart count in header if it exists
      const cartCountElements = document.querySelectorAll('.cart-count, .cart-count-bubble');
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
      });
      
      // Update pricing for the specific item
      updateItemPricing(itemKey, quantity, cart);
      
      // Update cart totals
      updateCartTotals(cart);
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      
      // Show error message
      showCartError(error.message);
      
      // Revert quantity input to previous value
      const input = document.querySelector(`input[data-item-key="${itemKey}"]`);
      const previousQuantity = getPreviousQuantity(itemKey);
      if (previousQuantity !== null) {
        input.value = previousQuantity;
      }
    })
    .finally(() => {
      // Remove loading states
      priceContainer.classList.remove('loading');
    });
  }
  
  // Store previous quantities for error handling
  const previousQuantities = new Map();
  
  // Function to get previous quantity
  function getPreviousQuantity(itemKey) {
    return previousQuantities.get(itemKey);
  }
  
  // Function to store current quantity before update
  function storeCurrentQuantity(itemKey) {
    const input = document.querySelector(`input[data-item-key="${itemKey}"]`);
    if (input) {
      previousQuantities.set(itemKey, parseInt(input.value));
    }
  }
  
  // Function to show cart error
  function showCartError(message) {
    const errorContainer = document.getElementById('cart-error');
    const errorMessage = document.getElementById('error-message');
    
    if (errorContainer && errorMessage) {
      errorMessage.textContent = message;
      errorContainer.style.display = 'block';
      
      // Auto-hide error after 5 seconds
      setTimeout(() => {
        hideCartError();
      }, 5000);
    }
  }
  
  // Function to hide cart error
  function hideCartError() {
    const errorContainer = document.getElementById('cart-error');
    if (errorContainer) {
      errorContainer.style.display = 'none';
    }
  }
  
  // Function to update item pricing
  function updateItemPricing(itemKey, quantity, cart) {
    const cartItem = cart.items.find(item => item.key === itemKey);
    if (cartItem) {
      const itemContainer = document.querySelector(`[data-item-key="${itemKey}"]`).closest('.cart-item');
      const priceElement = itemContainer.querySelector('.price-amount');
      const finalPrice = cartItem.final_line_price; // Already in cents, no need to convert
      
      if (priceElement) {
        priceElement.textContent = formatMoney(finalPrice);
      }
    }
  }
  
  // Function to update cart totals
  function updateCartTotals(cart) {
    // Update subtotal
    const subtotalElement = document.querySelector('.cart-subtotal-amount');
    if (subtotalElement) {
      subtotalElement.textContent = formatMoney(cart.total_price);
    }
    
    // Update total
    const totalElement = document.querySelector('.cart-total-amount');
    if (totalElement) {
      totalElement.textContent = formatMoney(cart.total_price);
    }
    
    // Update item count
    const countElement = document.querySelector('.cart-count');
    if (countElement) {
      countElement.textContent = `${cart.item_count} items`;
    }
  }
  
  // Helper function to format money using Shopify's format
  function formatMoney(amount) {
    // Use Shopify's money format if available, otherwise fallback to basic formatting
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(amount);
    }
    
    // Fallback to basic currency formatting
    const currency = window.Shopify?.currency?.active || 'USD';
    
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const accordion = document.querySelector('.product-page-description-accordion');
  if (accordion) {
    // Ensure accordion starts closed
    accordion.removeAttribute('open');
    
    // Add smooth slide animation
    accordion.addEventListener('toggle', function() {
      const content = this.querySelector('.product-page-description-content');
      if (this.open) {
        // Open animation - show content
        content.style.display = 'block';
      } else {
        // Close animation - hide content
        content.style.display = 'none';
      }
    });
    
    // Initialize closed state
    const content = accordion.querySelector('.product-page-description-content');
    content.style.display = 'none';
  }
  
  // Handle add to cart form submission
  const addToCartForm = document.querySelector('form[action*="/cart/add"]');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(this);
      const addToCartBtn = this.querySelector('.btn-add-to-cart');
      
      // Show loading state
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = addToCartBtn.dataset.loadingText || 'Adding...';
      }
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(item => {
        // Dispatch cart item added event
        document.dispatchEvent(new CustomEvent('cart:item:added', { detail: item }));
        
        // Reset form
        this.reset();
        
        // Show success message (optional)
        console.log('Item added to cart:', item);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        // Show error message (optional)
      })
      .finally(() => {
        // Reset button state
        if (addToCartBtn) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = addToCartBtn.dataset.originalText || 'Add to cart';
        }
      });
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
